// Preferência do colaborador de esconder o botão do VLibras (pedido do
// usuário, 2026-09-18: "usuário que não usa quer esconder o ícone"). Guardado
// em localStorage (por aparelho, não por conta) - VLibrasWidget.jsx e o
// toggle no drawer (LayoutBase.jsx) não têm relação de pai/filho entre si,
// então a sincronização entre os dois é feita por um CustomEvent em vez de
// contexto/prop.
const KEY = "vlibras_oculto";
const EVENTO = "vlibras-pref-changed";

export function isVLibrasOculto() {
    try {
        return localStorage.getItem(KEY) === "1";
    } catch {
        return false;
    }
}

export function setVLibrasOculto(oculto) {
    try {
        localStorage.setItem(KEY, oculto ? "1" : "0");
    } catch {
        // localStorage indisponível (modo privado etc.) - preferência só não
        // persiste entre sessões, widget continua funcionando normalmente.
    }
    window.dispatchEvent(new Event(EVENTO));
}

export function onVLibrasPrefChange(callback) {
    window.addEventListener(EVENTO, callback);
    return () => window.removeEventListener(EVENTO, callback);
}
